import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import '../nurturer-auth/styles/auth.css';
import AuthShell from '../nurturer-auth/components/AuthShell';
import AuthPageBrand from '../nurturer-auth/components/AuthPageBrand';
import { loginAside } from '../nurturer-auth/components/authAsides';
import LoginForm from '../nurturer-auth/forms/LoginForm';
import Modal from './components/modal';

function Login() {
  const { isAuth } = useSelector((state) => state.login);

  if (isAuth) {
    return <Redirect to="/apps/dashboard" />;
  }

  return (
    <>
      <Modal />
      <AuthShell aside={loginAside}>
        <AuthPageBrand />
        <div className="auth-head">
          <h1>
            Welcome <em>back</em>
          </h1>
          <p>Log in to review the touches Nurturer drafted for you.</p>
        </div>
        <LoginForm />
        <div className="alt">
          Don&apos;t have an account?{' '}
          <Link className="link" to="/register">
            Create one
          </Link>
        </div>
      </AuthShell>
    </>
  );
}

export default Login;
